import { FilterAction, trackEvent } from '@shared/utils';
import { FILTER_CONFIG, FilterKey } from '@retail/products/utils';

/** Route with numeric segments masked, so one assortment per page does not become one row per id in GA */
export const getTrackedPage = (pathname: string) => pathname.replace(/\/\d+(?=\/|$)/g, '/:id');

const isEmpty = (value: unknown) =>
  value === undefined ||
  value === null ||
  value === '' ||
  value === false ||
  value === 'UNSPECIFIED' ||
  (Array.isArray(value) && value.length === 0);

export const getFilterAction = (value: unknown): FilterAction => (isEmpty(value) ? 'clear' : 'set');

export const getValueCount = (value: unknown) => {
  if (isEmpty(value)) return 0;
  return Array.isArray(value) ? value.length : 1;
};

export const getActiveFilterCount = (filters: Record<string, unknown>) =>
  Object.values(filters).filter((value) => !isEmpty(value)).length;

export const trackFilterChanges = (
  pathname: string,
  currentFilters: Record<string, unknown>,
  updates: Record<string, unknown>
) => {
  const page = getTrackedPage(pathname);
  const activeFilterCount = getActiveFilterCount({ ...currentFilters, ...updates });
  (Object.entries(updates) as [FilterKey, unknown][]).forEach(([key, value]) => {
    trackEvent('filter_applied', {
      filter_key: key,
      filter_type: FILTER_CONFIG[key].type,
      page,
      action: getFilterAction(value),
      value_count: getValueCount(value),
      active_filter_count: activeFilterCount,
    });
  });
};

/** Skipped when nothing is active, so programmatic resets on mount do not count as user actions */
export const trackFiltersReset = (pathname: string, currentFilters: Record<string, unknown>) => {
  if (getActiveFilterCount(currentFilters) === 0) return;
  trackEvent('filters_reset', { page: getTrackedPage(pathname) });
};
